import _always from "ramda/es/always";
import _tryCatch from "ramda/es/tryCatch";
export default _tryCatch(JSON.parse, _always(undefined));